import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';

export default function EditItemModal({ item, onSave, onClose }) {
  const [productName, setProductName] = useState(item.product_name || '');
  const [quantity, setQuantity] = useState(item.quantity || 1);
  const [description, setDescription] = useState(item.description || '');
  const [link, setLink] = useState(item.link || '');

  const handleSave = () => {
    onSave(item.id, { product_name: productName, quantity, description, link });
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="bg-white border-[#EAE6DF]">
        <DialogHeader>
          <DialogTitle className="text-[#2F3E3B]">Rediger vare</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div className="space-y-1.5">
            <Label className="font-sans text-[#2F3E3B]">Varenavn</Label>
            <Input value={productName} onChange={e => setProductName(e.target.value)}
              className="border-[#EAE6DF]" data-testid="edit-item-name" />
          </div>
          <div className="space-y-1.5">
            <Label className="font-sans text-[#2F3E3B]">Antal</Label>
            <Input type="number" min="1" value={quantity}
              onFocus={e => e.target.select()}
              onChange={e => setQuantity(parseInt(e.target.value) || '')}
              onBlur={e => { if (!e.target.value) setQuantity(1); }}
              className="border-[#EAE6DF]" data-testid="edit-item-quantity" />
          </div>
          <div className="space-y-1.5">
            <Label className="font-sans text-[#2F3E3B]">Beskrivelse</Label>
            <Input value={description} onChange={e => setDescription(e.target.value)}
              placeholder="Tilføj beskrivelse..." className="border-[#EAE6DF]" data-testid="edit-item-description" />
          </div>
          <div className="space-y-1.5">
            <Label className="font-sans text-[#2F3E3B]">Link</Label>
            <Input value={link} onChange={e => setLink(e.target.value)}
              placeholder="https://..." className="border-[#EAE6DF]" data-testid="edit-item-link" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="font-sans">Annuller</Button>
          <Button onClick={handleSave} disabled={!productName.trim()} className="bg-[#7F9C82] hover:bg-[#658368] text-white font-sans"
            data-testid="save-item-button">Gem</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
